import { render, staticRenderFns } from "./contentFavoriteCourse.vue?vue&type=template&id=8167d79a&"
import script from "./contentFavoriteCourse.vue?vue&type=script&lang=js&"
export * from "./contentFavoriteCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports